// Product Detail Data with SEO-optimized content
export const productDetails = {
  'branding-labels': {
    images: [
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/i574nzka_WhatsApp%20Image%202026-05-30%20at%2017.06.01%20%283%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/902u2ff8_WhatsApp%20Image%202026-05-30%20at%2017.06.46%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9y2tf73z_WhatsApp%20Image%202026-05-30%20at%2017.06.46%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/asuqif41_WhatsApp%20Image%202026-05-30%20at%2017.06.46.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/i5gqj403_WhatsApp%20Image%202026-05-30%20at%2017.07.25.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/o1huhcet_WhatsApp%20Image%202026-05-30%20at%2017.07.24.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/ra8nnhvq_WhatsApp%20Image%202026-05-30%20at%2017.06.01%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/iwac2cdn_WhatsApp%20Image%202026-05-30%20at%2017.06.01%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/f4v4r8n0_WhatsApp%20Image%202026-05-30%20at%2017.06.01.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/1v0mjdld_WhatsApp%20Image%202026-05-30%20at%2017.07.59.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/fmbmo2or_WhatsApp%20Image%202026-05-30%20at%2017.09.31.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9ug3u86e_WhatsApp%20Image%202026-05-30%20at%2017.09.49.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9cvfz5is_WhatsApp%20Image%202026-05-30%20at%2017.14.43%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9ivnd7zi_WhatsApp%20Image%202026-05-30%20at%2017.14.43.jpeg'
    ],
    en: {
      title: 'Custom Woven & Care Labels',
      subtitle: 'Custom woven, printed care and heat transfer labels for clothing brands and textile manufacturers.',
      description: 'Etiteks has been manufacturing labels in Istanbul since 1983, supplying clothing brands and textile producers across Europe and beyond. Our range includes woven brand labels, printed care labels and heat transfers, with embroidered, leather and silicone options also available. We help you select the label construction, cut and fold to suit your artwork and how the label will be attached to your product.',
      features: [
        'High-density woven labels for detailed logos and lettering',
        'Embroidered labels with textured designs',
        'Printed care labels for wash instructions and fibre composition',
        'Heat transfer labels for branding applied directly to garments',
        'Leather labels and patches for brand identification',
        'Custom-moulded silicone labels',
        'Recycled material options for selected label constructions'
      ],
      technicalSpecs: {
        'Cut Types': ['Ultrasonic Slit', 'Laser Cut', 'Hot Cut', 'Die Cut'],
        'Fold Types': ['End Fold', 'Center Fold', 'Mitre Fold', 'Manhattan Fold', 'Book Cover'],
        'Qualities': ['Taffeta', 'Satin', 'Damask', 'High Definition (HD)', 'Reverse Satin']
      },
      highlights: [
        {
          icon: 'sparkles',
          title: 'Premium Quality',
          description: 'Choose from damask, satin and other available qualities to suit your logo detail, preferred texture and garment application.'
        },
        {
          icon: 'palette',
          title: 'Custom Design',
          description: 'Customise your label with your artwork and select suitable cut and fold options for its placement on the product.'
        },
        {
          icon: 'leaf',
          title: 'Eco-Friendly Options',
          description: 'Recycled polyester and organic cotton options are available. Material suitability and certification coverage depend on the selected label.'
        }
      ]
    },
    tr: {
      title: 'Marka & Bakım Etiketleri',
      subtitle: 'Marka kimliğinizi tanımlayan premium dokuma, baskılı, bakım ve özel etiketler',
      description: 'Marka ve bakım etiketlerimiz, ürünlerinizi yükseltmek ve kaliteyi iletmek için hassasiyetle üretilmektedir. Lüks dokuma etiketlerden karmaşık nakışlı tasarımlara, baskılı bakım etiketlerine, ısı transfer etiketlerine, deri yamalara ve yenilikçi silikon etiketlere kadar müşterilerinizde kalıcı izler bırakan eksiksiz bir marka ve bakım etiketi çözümleri yelpazesi sunuyoruz.',
      features: [
        'Ultra ince detaylı yüksek yoğunluklu dokuma etiketler',
        '3D doku efektli premium nakışlı etiketler',
        'Baskılı bakım ve yıkama talimatı etiketleri (ISO 3758 uyumlu)',
        'Etiket hissi olmayan konfor için ısı transfer etiketleri',
        'Lüks markalama için hakiki deri etiketler ve yamalar',
        'Özel kalıplama ile esnek silikon etiketler',
        'Geri dönüştürülmüş malzemelerle sürdürülebilir seçenekler'
      ],
      technicalSpecs: {
        'Kesim Tipleri': ['Ultrasonik Kesim', 'Lazer Kesim', 'Sıcak Kesim', 'Kalıp Kesim'],
        'Katlama Tipleri': ['Uç Katlama', 'Orta Katlama', 'Gönye Katlama', 'Manhattan Katlama', 'Kitap Kapağı'],
        'Kaliteler': ['Tafta', 'Saten', 'Damask', 'Yüksek Çözünürlük (HD)', 'Ters Saten']
      },
      highlights: [
        {
          icon: 'sparkles',
          title: 'Premium Kalite',
          description: 'Giysileriniz kadar uzun ömürlü etiketler için en kaliteli iplikler ve malzemeler kullanıyoruz.'
        },
        {
          icon: 'palette',
          title: 'Özel Tasarım',
          description: 'Tasarım ekibimiz, markanızı mükemmel şekilde temsil eden benzersiz etiketler oluşturmak için sizinle çalışır.'
        },
        {
          icon: 'leaf',
          title: 'Çevre Dostu Seçenekler',
          description: 'Geri dönüştürülmüş polyester ve organik pamuk dahil sürdürülebilir malzemeler mevcuttur.'
        }
      ]
    }
  },
  'hang-tags': {
    images: [
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/0lgz2jbk_WhatsApp%20Image%202026-05-30%20at%2017.19.37%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/0lrxzs8r_WhatsApp%20Image%202026-05-30%20at%2017.19.37%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9rxt9dmf_10_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/0q70orn4_11_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/ka35rzhc_IMG_3469_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/ogubjz3i_IMG_3470_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/55lxmvrh_WhatsApp%20Image%202026-05-30%20at%2017.19.38.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/eezd7kwy_WhatsApp%20Image%202026-05-30%20at%2017.19.37.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/49xjw08z_WhatsApp%20Image%202026-05-30%20at%2017.21.24%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/8cfg95p2_WhatsApp%20Image%202026-05-30%20at%2017.21.24%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/5zaaot0b_WhatsApp%20Image%202026-05-30%20at%2017.21.24.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/as5clyvf_WhatsApp%20Image%202026-05-30%20at%2017.21.23.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/mihzah17_WhatsApp%20Image%202026-05-30%20at%2017.23.18.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/ggmvjesz_WhatsApp%20Image%202026-05-30%20at%2017.23.17.jpeg'
    ],
    en: {
      title: 'Hang Tags',
      subtitle: 'Custom hang tags that tell your brand story and captivate customers',
      description: 'Our hang tags are more than just price carriers – they\'re powerful brand ambassadors. We create stunning hang tags that communicate your brand values, product information, and story through premium materials, innovative designs, and expert craftsmanship. From minimalist elegance to bold statements, we bring your vision to life.',
      features: [
        'Premium cardstock with various textures and finishes',
        'Custom die-cut shapes for unique brand identity',
        'Foil stamping, embossing, and debossing options',
        'Eco-friendly recycled and FSC-certified papers',
        'String options including cotton, hemp, and satin ribbon',
        'QR codes and NFC integration for digital connectivity'
      ],
      technicalSpecs: {
        'Paper Stocks': ['FSC® Certified Papers', 'Kraft', 'Coated Art Paper', 'Black/Specialty Boards (300gsm - 800gsm)'],
        'Finishes': ['Matte/Gloss Lamination', 'Spot UV', 'Embossing/Debossing', 'Hot Foil Stamping'],
        'Strings & Seals': ['Waxed Cotton', 'Hemp', 'Elastic', 'Satin Ribbon', 'Plastic/Alloy Seals']
      },
      highlights: [
        {
          icon: 'file-text',
          title: 'Premium Materials',
          description: 'From textured cardstock to specialty papers, we offer materials that feel as good as they look.'
        },
        {
          icon: 'tag',
          title: 'Custom Shapes',
          description: 'Stand out with unique die-cut shapes that reflect your brand personality.'
        },
        {
          icon: 'recycle',
          title: 'Sustainable Choice',
          description: 'FSC-certified papers and soy-based inks for environmentally conscious brands.'
        }
      ]
    },
    tr: {
      title: 'Karton Etiketler',
      subtitle: 'Marka hikayenizi anlatan ve müşterileri büyüleyen özel karton etiketler',
      description: 'Karton etiketlerimiz sadece fiyat taşıyıcıları değil – güçlü marka elçileridir. Premium malzemeler, yenilikçi tasarımlar ve uzman işçilik aracılığıyla marka değerlerinizi, ürün bilgilerinizi ve hikayenizi ileten çarpıcı karton etiketler oluşturuyoruz. Minimalist şıklıktan cesur ifadelere kadar vizyonunuzu hayata geçiriyoruz.',
      features: [
        'Çeşitli doku ve yüzeylerle premium karton',
        'Benzersiz marka kimliği için özel kesim şekilleri',
        'Folyo baskı, kabartma ve çökertme seçenekleri',
        'Çevre dostu geri dönüştürülmüş ve FSC sertifikalı kağıtlar',
        'Pamuk, kenevir ve saten kurdele dahil ip seçenekleri',
        'Dijital bağlantı için QR kodları ve NFC entegrasyonu'
      ],
      technicalSpecs: {
        'Kağıt Türleri': ['FSC® Sertifikalı Kağıtlar', 'Kraft', 'Kuşe Kağıt', 'Siyah/Özel Kartonlar (300gsm - 800gsm)'],
        'Yüzey İşlemleri': ['Mat/Parlak Laminasyon', 'Spot UV', 'Kabartma/Çökertme', 'Sıcak Folyo Baskı'],
        'İpler & Mühürler': ['Mumlu Pamuk', 'Kenevir', 'Elastik', 'Saten Kurdele', 'Plastik/Alaşım Mühürler']
      },
      highlights: [
        {
          icon: 'file-text',
          title: 'Premium Malzemeler',
          description: 'Dokulu kartondan özel kağıtlara kadar, göründüğü kadar iyi hissettiren malzemeler sunuyoruz.'
        },
        {
          icon: 'tag',
          title: 'Özel Şekiller',
          description: 'Marka kişiliğinizi yansıtan benzersiz kesim şekilleriyle öne çıkın.'
        },
        {
          icon: 'recycle',
          title: 'Sürdürülebilir Seçim',
          description: 'Çevre bilincine sahip markalar için FSC sertifikalı kağıtlar ve soya bazlı mürekkepler.'
        }
      ]
    }
  },
  'care-composition': {
    images: [
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/40g9b2ci_WhatsApp%20Image%202026-05-30%20at%2017.24.41.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/1ag383us_WhatsApp%20Image%202026-05-30%20at%2017.24.40.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/m2rvbxxf_WhatsApp%20Image%202026-05-30%20at%2017.25.31%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/b2byvp4o_WhatsApp%20Image%202026-05-30%20at%2017.25.31%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/cp018hj2_WhatsApp%20Image%202026-05-30%20at%2017.25.31.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/9svujeo7_da9638bb-ec63-4d64-a7ae-879a8ebfab30.jpg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/vztjjen2_WhatsApp%20Image%202026-05-30%20at%2017.24.06%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/c39purqb_WhatsApp%20Image%202026-05-30%20at%2017.24.23.jpeg'
    ],
    en: {
      title: 'Patches',
      subtitle: 'Embroidered, woven, leather, PVC and silicone patches for premium branding',
      description: 'Our patches add a tactile, high-quality dimension to your products. Whether it\'s a classic embroidered patch, a refined woven design, genuine leather detailing, or a modern PVC and silicone badge — we produce patches that elevate brand identity across fashion, sportswear, outdoor, and workwear segments.',
      features: [
        'Embroidered patches with up to 15 thread colors',
        'Woven patches with fine detail and soft hand feel',
        'Genuine and faux leather patches with debossing and embossing',
        'PVC and silicone patches with 2D/3D custom molding',
        'Iron-on, sew-on, and Velcro backing options',
        'Custom shapes, sizes and pantone color matching'
      ],
      technicalSpecs: {
        'Types': ['Embroidered', 'Woven', 'Leather (Genuine & Faux)', 'PVC / Silicone', 'Printed'],
        'Attachment': ['Iron-On (Heat Seal)', 'Sew-On', 'Velcro / Hook & Loop', 'Self-Adhesive'],
        'Finishing': ['Merrow Border', 'Laser Cut Edge', 'Die Cut', 'Heat Cut', 'Woven Edge']
      },
      highlights: [
        {
          icon: 'sparkles',
          title: 'Premium Craftsmanship',
          description: 'Precision detailing with high thread density and durable materials for long-lasting quality.'
        },
        {
          icon: 'palette',
          title: 'Fully Customizable',
          description: 'Any shape, size, color or material — we bring your brand vision to life.'
        },
        {
          icon: 'shield',
          title: 'Built to Last',
          description: 'Wash-resistant, color-fast patches designed to endure the lifetime of the garment.'
        }
      ]
    },
    tr: {
      title: 'Yamalar',
      subtitle: 'Premium markalama icin nakis, dokuma, deri, PVC ve silikon yamalar',
      description: 'Yamalarımız ürünlerinize dokunsal, yüksek kaliteli bir boyut katar. Klasik nakış yaması, zarif dokuma tasarım, hakiki deri detay veya modern PVC ve silikon rozet — moda, spor giyim, outdoor ve iş giyim segmentlerinde marka kimliğini yükselten yamalar üretiyoruz.',
      features: [
        '15 iplik rengine kadar nakış yamaları',
        'İnce detay ve yumuşak tuşeye sahip dokuma yamalar',
        'Kabartma ve çökertme ile hakiki ve suni deri yamalar',
        '2D/3D özel kalıplama ile PVC ve silikon yamalar',
        'Ütüyle yapışan, dikişle takılan ve cırt cırt seçenekleri',
        'Özel şekiller, boyutlar ve pantone renk eşleştirmesi'
      ],
      technicalSpecs: {
        'Türler': ['Nakış', 'Dokuma', 'Deri (Hakiki & Suni)', 'PVC / Silikon', 'Baskılı'],
        'Tutturma': ['Ütüyle Yapışan (Isı Mühür)', 'Dikişle Takılan', 'Cırt Cırt', 'Kendinden Yapışkanlı'],
        'Son İşlem': ['Overlok Kenar', 'Lazer Kesim', 'Kalıp Kesim', 'Sıcak Kesim', 'Dokuma Kenar']
      },
      highlights: [
        {
          icon: 'sparkles',
          title: 'Premium İşçilik',
          description: 'Uzun ömürlü kalite için yüksek iplik yoğunluğu ve dayanıklı malzemelerle hassas detaylandırma.'
        },
        {
          icon: 'palette',
          title: 'Tamamen Özelleştirilebilir',
          description: 'Her şekil, boyut, renk veya malzeme — marka vizyonunuzu hayata geçiriyoruz.'
        },
        {
          icon: 'shield',
          title: 'Dayanıklı Tasarım',
          description: 'Giysinin ömrü boyunca dayanacak şekilde tasarlanmış yıkamaya dayanıklı, renk haslığı yüksek yamalar.'
        }
      ]
    }
  },
  'packaging': {
    images: [
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/pchkfrcj_02%20-%20Kopya%20%281%29_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/ewtq9ju3_03%20-%20Kopya%20%28%C3%9Cr%C3%BCn%20iyile%C5%9Ftirici%29%20%281%29%20%281%29_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/yaw2cda5_05_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/644ydqgj_06_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/6wl97fqz_19_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/bkcujw6n_20_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/gk1aapw6_18%20%281%29_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/cn61bm8e_21%20%281%29_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/tpadadg2_27_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/dzhazkyp_32_result.webp',
      'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/0s8d22v0_35_result.webp'
    ],
    en: {
      title: 'Packaging Solutions',
      subtitle: 'Premium packaging that elevates your brand and protects your products',
      description: 'Our packaging solutions combine form and function to create memorable unboxing experiences. From elegant gift boxes to sustainable poly bags, we design and manufacture packaging that reflects your brand\'s quality and values. Every package we create is an opportunity to make a lasting impression.',
      features: [
        'Custom rigid boxes with magnetic closures',
        'Luxury paper bags with rope handles',
        'Eco-friendly poly bags and mailers',
        'Tissue paper with custom printing',
        'Ribbon and bow accessories',
        'Protective garment bags for shipping'
      ],
      technicalSpecs: {
        'Box Styles': ['Rigid Boxes (Luxury & Cosmetic)', 'Magnetic Closure Boxes', 'Foldable Boxes', 'Drawer & Sleeve Boxes'],
        'Specialty Features': ['Custom Inserts (Foam/Cardboard for bottles & jars)', 'Window Patching'],
        'Bag Types': ['Luxury Carrier Bags', 'E-commerce Mailers', 'Polybags (Recycled LDPE)'],
        'Printing & Finishes': ['Offset Printing', 'UV Coating', 'Hot Foil Stamping', 'Soft-Touch Lamination']
      },
      highlights: [
        {
          icon: 'package',
          title: 'Unboxing Experience',
          description: 'Create memorable moments with packaging designed to delight your customers.'
        },
        {
          icon: 'gift',
          title: 'Gift-Ready',
          description: 'Premium finishes and elegant designs make every product gift-worthy.'
        },
        {
          icon: 'globe',
          title: 'Eco-Conscious',
          description: 'Sustainable materials and recyclable options for environmentally responsible packaging.'
        }
      ]
    },
    tr: {
      title: 'Ambalaj Çözümleri',
      subtitle: 'Markanızı yükselten ve ürünlerinizi koruyan premium ambalaj',
      description: 'Ambalaj çözümlerimiz, unutulmaz kutu açma deneyimleri yaratmak için form ve işlevi birleştirir. Zarif hediye kutularından sürdürülebilir poli torbalara kadar, markanızın kalitesini ve değerlerini yansıtan ambalajlar tasarlıyor ve üretiyoruz. Oluşturduğumuz her paket, kalıcı bir izlenim bırakma fırsatıdır.',
      features: [
        'Manyetik kapaklı özel sert kutular',
        'İp saplı lüks kağıt çantalar',
        'Çevre dostu poli torbalar ve zarflar',
        'Özel baskılı pelür kağıdı',
        'Kurdele ve fiyonk aksesuarları',
        'Sevkiyat için koruyucu giysi poşetleri'
      ],
      technicalSpecs: {
        'Kutu Stilleri': ['Sert Kutular (Lüks & Kozmetik)', 'Manyetik Kapaklı Kutular', 'Katlanır Kutular', 'Çekmece & Kılıf Kutular'],
        'Özel Özellikler': ['Özel İç Düzenler (Şişe & kavanozlar için Köpük/Karton)', 'Pencere Açma'],
        'Çanta Tipleri': ['Lüks Taşıma Çantaları', 'E-ticaret Zarfları', 'Poli Torbalar (Geri Dönüştürülmüş LDPE)'],
        'Baskı & Yüzey İşlemleri': ['Ofset Baskı', 'UV Kaplama', 'Sıcak Folyo Baskı', 'Yumuşak Dokunuş Laminasyon']
      },
      highlights: [
        {
          icon: 'package',
          title: 'Kutu Açma Deneyimi',
          description: 'Müşterilerinizi memnun etmek için tasarlanmış ambalajlarla unutulmaz anlar yaratın.'
        },
        {
          icon: 'gift',
          title: 'Hediyeye Hazır',
          description: 'Premium yüzeyler ve zarif tasarımlar her ürünü hediye değerinde kılar.'
        },
        {
          icon: 'globe',
          title: 'Çevre Bilinçli',
          description: 'Çevreye duyarlı ambalaj için sürdürülebilir malzemeler ve geri dönüştürülebilir seçenekler.'
        }
      ]
    }
  }
};
